import * as yup from 'yup';

export const SendInviteFormSchema = yup
  .object({
    accessLevel: yup.string().required('Please select an Access Level'),
    email: yup
      .string()
      .email('Invalid format. Please enter valid email.')
      .matches(
        /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Please enter valid email. Only letters (a-z), numbers (0-9), period (.) and underscore (_) are allowed.',
      )
      .required('Please enter Email'),
  })
  .required();
